import { memo } from 'react';
import styled from 'styled-components';
import { spacing } from '@cbhq/cds-web/tokens';
import devices from '../shared/styles/devices.js';
import { theme } from '../shared/styles/theme.js';
import { linkItem } from './FooterLink.js';
import { jsxs } from 'react/jsx-runtime';
const COINBASE_LABEL = 'Coinbase';
function CopyrightCoinbase() {
  return /*#__PURE__*/jsxs(Copyright, {
    children: ["\xA9 ", new Date().getFullYear(), " ", COINBASE_LABEL]
  });
}
const Copyright = styled.div`
  ${linkItem};
  margin-top: 0;
  margin-bottom: ${spacing[1]};

  @media (${devices.phone}) {
    font-size: ${theme.fontSize.large};
  }
`;
const Copyright$1 = /*#__PURE__*/memo(CopyrightCoinbase);
export { Copyright$1 as default };
//# sourceMappingURL=Copyright.js.map
